import {
  type EnvironmentProviders,
  makeEnvironmentProviders,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { tuiHintOptionsProvider } from '@taiga-ui/core/portals/hint';
import { provideTaiga } from '@taiga-ui/core/utils/miscellaneous';
import { tuiSwitchOptionsProvider } from '@taiga-ui/kit/components/switch';
import { tuiToastOptionsProvider } from '@taiga-ui/kit/components/toast';

import { provideI18n } from '../i18n/i18n.providers';

import { provideAuth } from '../auth/auth.providers';
import { provideErrorHandling } from '../error/error.providers';
import { provideHttp } from '../http/http.providers';
import { provideTheme } from '../theme/theme.providers';
import { CountriesApi, HttpCountriesApi } from '../countries/countries.api';
import { HttpNotificationsApi, NotificationsApi } from '../notifications-drawer/notifications.api';
import { HttpProjectsApi, ProjectsApi } from '../projects/projects.api';
import { HttpSupportApi, SupportApi } from '../support/support.api';
import { HttpWorkspacesApi, WorkspacesApi } from '../workspaces/workspaces.api';
import { AiApi, HttpAiApi } from '../ai/ai.api';

export function provideCore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideBrowserGlobalErrorListeners(),
    provideTaiga({ apis: 'stable', scrollbars: 'native' }),
    tuiHintOptionsProvider({ showDelay: 0, hideDelay: 0 }),
    tuiToastOptionsProvider({ block: 'end', inline: 'end' }),
    tuiSwitchOptionsProvider({ showIcons: false }),
    provideI18n(),
    provideErrorHandling(),
    provideHttp(),
    provideTheme(),
    provideAuth(),
    { provide: SupportApi, useClass: HttpSupportApi },
    { provide: AiApi, useClass: HttpAiApi },
    { provide: WorkspacesApi, useClass: HttpWorkspacesApi },
    { provide: CountriesApi, useClass: HttpCountriesApi },
    { provide: ProjectsApi, useClass: HttpProjectsApi },
    { provide: NotificationsApi, useClass: HttpNotificationsApi },
  ]);
}
